import React from 'react';
import ProtectedRoute from './protected';
import CalendarPage from '../pages/calendar';

export const CalendarRoutes = [
  <ProtectedRoute exact path='/calendar' component={CalendarPage} />,
  // <ProtectedRoute exact path='/attendance/schedule/view/:ref' component={AttendanceScheduleViewPage} />,
];